var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-client-table',{staticClass:"w-100",attrs:{"id":"audit-change-log-table","columns":_vm.columns,"data":_vm.rows,"options":_vm.options,"theme":_vm.theme}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }